import {LayoutHeroHeadingCenter} from './LayoutHeroHeadingCenter';
import {LayoutHeroHeadingLeft} from './LayoutHeroHeadingLeft';
import {LayoutHeroHeadingRight} from './LayoutHeroHeadingRight';
import {LayoutHeroStack} from './LayoutHeroStack';
import {LayoutHeroSubscribeLeft} from './LayoutHeroSubscribeLeft';
import {LayoutHeroSubscribeRight} from './LayoutHeroSubscribeRight';
import {LayoutHeroWithoutImage} from './LayoutHeroWithoutImage';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Hero';

export const HeroHeadingCenter = {
  category,
  displayName: 'Hero Heading Center',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroHeadingCenter,
  layout: LayoutHeroHeadingCenter,
};

export const HeroHeadingLeft = {
  category,
  displayName: 'Hero Heading Left',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroHeadingLeft,
  layout: LayoutHeroHeadingLeft,
};

export const HeroHeadingRight = {
  category,
  displayName: 'Hero Heading Right',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroHeadingRight,
  layout: LayoutHeroHeadingRight,
};

export const HeroStack = {
  category,
  displayName: 'Hero Stack',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroStack,
  layout: LayoutHeroStack,
};

export const HeroSubscribeLeft = {
  category,
  displayName: 'Hero Subscribe Left',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroSubscribeLeft,
  layout: LayoutHeroSubscribeLeft,
};

export const HeroSubscribeRight = {
  category,
  displayName: 'Hero Subscribe Right',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroSubscribeRight,
  layout: LayoutHeroSubscribeRight,
};

export const HeroWithoutImage = {
  category,
  displayName: 'Hero Without Image',
  previewImageURL: prebuiltLayoutPreviewImages.layoutHeroWithoutImage,
  layout: LayoutHeroWithoutImage,
};
